import { render, staticRenderFns } from "./decorDialog.vue?vue&type=template&id=11165436&scoped=true"
import script from "./decorDialog.vue?vue&type=script&lang=js"
export * from "./decorDialog.vue?vue&type=script&lang=js"
import style0 from "./decorDialog.vue?vue&type=style&index=0&id=11165436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11165436",
  null
  
)

export default component.exports